import { useLocation } from 'react-router-dom';
import { Link } from 'components/Link/Link';
import Home3 from 'images/icons/whiteIcons/Home 3.svg';
import './styles.scss';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');

    return (
        <div className="breadcrumbs">
            <Link href="/">
                <img src={Home3} alt="home" />
            </Link>
            <div className="breadcrumbs-dot"></div>
            {pathSegments.map((segment, index) => (
                <span key={segment} className="breadcrumbs-span">
                    <Link
                        href={`/${pathSegments.slice(0, index + 1).join('/')}`}
                        className="body3"
                    >
                        {segment.toUpperCase()}
                    </Link>
                    {index < pathSegments.length - 1 && <div className="breadcrumbs-dot margin-left"></div>}
                </span>
            ))}
        </div>
    );
};

export default Breadcrumbs;
